import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { XIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AddEmployeeForm } from 'components/AddEmployeeForm';

export const AddPatientDialog = (): React.ReactElement => {
  const { hideDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return (
    <Dialog
      title={t('InsuredPersonsList.addPerson.cta')}
      open
      enableOutsideClick={false}
      className="max-h-131 overflow-y-auto w-3xl"
    >
      <AddEmployeeForm
        mode="standalone"
        onSuccess={hideDialog}
        buttons={{
          cancel: {
            onClick: hideDialog,
            children: (
              <>
                <XIcon className="size-6 text-red-400" strokeWidth={0.75} />
                {t('Common.cancel', { ns: LOCIZE_NS.COMMON })}
              </>
            ),
          },
        }}
      />
    </Dialog>
  );
};
